import React, { useState } from 'react';
import { Table, Button, Modal, Form, Input, Tag, Space, message } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, SaveOutlined } from '@ant-design/icons';
import { PostSceneName, DeleteSceneName } from '../../../dao/jutge/GetJavamonConfig';

interface TabSceneActivitiesProps {
    isAdmin: boolean;
    loading: boolean;
    sceneActivities?: any[];
    sceneNames: any[];
    aulas?: any[];
    activitats?: any[];
    fetchSceneActivities?: () => Promise<void>;
    fetchSceneNames: () => Promise<void>;
}

export const TabSceneActivities: React.FC<TabSceneActivitiesProps> = ({
    isAdmin,
    loading,
    sceneNames,
    fetchSceneNames
}) => {
    const [sceneNameModal, setSceneNameModal] = useState(false);
    const [editingSceneName, setEditingSceneName] = useState<any>(null);
    const [sceneNameForm] = Form.useForm();

    const handleSaveSceneName = async (values: any) => {
        try {
            const body = { ...values, id: editingSceneName?.id || 0 };
            const res = await PostSceneName(body);
            if (!res) throw new Error('Error');
            message.success("Nombre de escena guardado");
            setSceneNameModal(false);
            fetchSceneNames();
        } catch (e) {
            message.error("Error al guardar");
        }
    };

    const handleDeleteSceneName = async (id: number) => {
        try {
            const res = await DeleteSceneName(id);
            if (!res) throw new Error('Error');
            message.success("Nombre visible eliminado");
            fetchSceneNames();
        } catch (e) {
            message.error("Error al eliminar");
        }
    };

    const columnsSceneNames = [
        { title: 'ID', dataIndex: 'id', key: 'id' },
        { title: 'Escena (Unity)', dataIndex: 'scene_name', key: 'scene_name', render: (v: string) => <Tag color="geekblue">{v}</Tag> },
        { title: 'Nombre visible', dataIndex: 'display_name', key: 'display_name', render: (v: string) => <b>{v}</b> },
        ...(isAdmin ? [{
            title: 'Acciones',
            key: 'actions',
            render: (_: any, record: any) => (
                <Space>
                    <Button icon={<EditOutlined />} onClick={() => { setEditingSceneName(record); sceneNameForm.setFieldsValue(record); setSceneNameModal(true); }} />
                    <Button danger icon={<DeleteOutlined />} onClick={() => {
                        Modal.confirm({
                            title: '¿Eliminar?',
                            content: `¿Seguro que quieres eliminar el nombre visible de la escena ${record.scene_name}?`,
                            onOk: () => handleDeleteSceneName(record.id)
                        });
                    }} />
                </Space>
            )
        }] : [])
    ];

    return (
        <div>
            <h3 style={{ marginTop: 0 }}>Nombres visibles de Escenas</h3>
            <div style={{ marginBottom: 12, padding: '10px 14px', background: '#f0f2f5', borderRadius: 8 }}>
                Asigna un nombre amigable a cada escena de Unity (ej. <b>Pueblo 2</b> → <b>Pueblo Maravilla</b>).
                Es global: se mostrará al jugador en el botón de viajar del juego en lugar del identificador técnico.
            </div>
            <Space style={{ marginBottom: 16 }}>
                {isAdmin && (
                    <Button type="primary" icon={<PlusOutlined />} onClick={() => { setEditingSceneName(null); sceneNameForm.resetFields(); setSceneNameModal(true); }}>
                        Añadir Nombre
                    </Button>
                )}
            </Space>
            <Table dataSource={sceneNames} columns={columnsSceneNames} loading={loading} rowKey="id" />

            {/* Modal Nombre visible de Escena */}
            <Modal
                title={editingSceneName ? "Editar Nombre de Escena" : "Nuevo Nombre de Escena"}
                open={sceneNameModal}
                onCancel={() => setSceneNameModal(false)}
                footer={null}
            >
                <Form form={sceneNameForm} layout="vertical" onFinish={handleSaveSceneName}>
                    <Form.Item name="scene_name" label="Escena de Unity (identificador técnico, Ej. Pueblo 2)" rules={[{ required: true }]}>
                        <Input placeholder="Ej: Pueblo 2" />
                    </Form.Item>
                    <Form.Item name="display_name" label="Nombre visible para el jugador" rules={[{ required: true }]}>
                        <Input placeholder="Ej: Pueblo Maravilla" />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" icon={<SaveOutlined />} block>
                            Guardar
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};
